// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VxER","input":"styles_input__2zo4M"};